import React from 'react'
import styled from 'styled-components'
import { Dialog } from '@progress/kendo-react-dialogs'
import { Button } from '@progress/kendo-react-buttons'

export default (props) =>
    <Dialog>
        <p style={{ fontSize: '18px' }}>Möchten Sie den Eintrag wirklich löschen?</p>
        <ButtonSection style={{ marginTop: '15px' }}>
            <StyledButton onClick={props.cancel}>Abbrechen</StyledButton>
            <StyledButton primary onClick={props.remove}>Löschen</StyledButton>
        </ButtonSection>
    </Dialog>

const ButtonSection = styled.div`
    display: flex;
    justify-content: flex-end;
`

const StyledButton = styled(Button)`
    margin-left: 10px;
`



// WEBPACK FOOTER //
// ./src/components/dialog/ConfirmDeleteDialog.js